import type { FC } from "react";
import type { RouterPathname } from "../../../../routing";
import { InboxUnreadCountBadge } from "./InboxUnreadCountBadge";

export const BADGE_PATH_MAP: Partial<Record<RouterPathname, FC>> = {
  "/messaging/inbox": InboxUnreadCountBadge,
} as const;
